import React from "react";
import { useTranslation } from "react-i18next";
import ConfirmDialog from "./ui/ConfirmDialog";
import "./ui/ui.css";

/** Deletion confirmation: `deleteHandle()` then `setOpen(false)`. */
export default function Popup({ children, open = false, setOpen, deleteHandle }) {
  const { t } = useTranslation();
  return (
    <ConfirmDialog
      open={open}
      onClose={() => setOpen(false)}
      onConfirm={deleteHandle}
      confirmLabel={t("Delete")}
      danger
    >
      {children}
    </ConfirmDialog>
  );
}
